export function calculateRemainder(item) {
  const {
    billedAmount,
    otherPaymentsAmount,
    outstanding,
    otherPayerDebits,
    patient,
    adjustment,
    paid,
  } = item;

  return (
    billedAmount -
    otherPaymentsAmount -
    outstanding -
    otherPayerDebits -
    patient -
    adjustment -
    paid
  );
}
